export default "__VITE_ASSET__a88a51b7__"